// API Configuration
const NODE_ENV = "Production";

export const API_CONFIG = {
  BASE_URL:  NODE_ENV === 'Production' ? 'https://api.chittifinserv.com/api' : 'http://localhost:5000/api',
  ASSETS_URL:NODE_ENV === 'Production' ? 'https://api.chittifinserv.com' : 'http://localhost:5000',
  TIMEOUT: 30000,
  ENDPOINTS: {
    // Auth endpoints
    AUTH: {
      LOGIN: '/auth/login',
      LOGOUT: '/auth/logout',
      ME: '/auth/me',
      PROFILE: '/auth/profile',
      CHANGE_PASSWORD: '/auth/change-password',
    },
    // User endpoints
    USERS: {
      LIST: '/users',
      MY_USERS: '/users/my-users',
      DETAIL: (id) => `/users/${id}`,
      CREATE: '/users',
      UPDATE: (id) => `/users/${id}`,
      DELETE: (id) => `/users/${id}`,
      STATUS: (id) => `/users/${id}/status`,
    },
    // Category endpoints
    CATEGORIES: {
      LIST: '/categories',
      DETAIL: (id) => `/categories/${id}`,
      CREATE: '/categories',
      UPDATE: (id) => `/categories/${id}`,
      DELETE: (id) => `/categories/${id}`,
      STATUS: (id) => `/categories/${id}/status`,
    },
    // Loan Applications endpoints
    APPLICATIONS: {
      LIST: '/loan-applications',
      DETAIL: (id) => `/loan-applications/${id}`,
      CREATE: '/loan-applications/admin',
      UPDATE: (id) => `/loan-applications/${id}`,
      DELETE: (id) => `/loan-applications/${id}`,
      STATUS: (id) => `/loan-applications/${id}/status`,
      BY_USER: (userId) => `/loan-applications/user/${userId}`,
      STATS: '/loan-applications/stats/dashboard',
    },
    // Configuration endpoints
    CONFIG: {
      GET: '/configuration',
      UPDATE: '/configuration',
      SPLASH: '/configuration/splash',
      LOGIN: '/configuration/login',
      CONTACT: '/configuration/contact',
      LEGAL: '/configuration/legal',
      THEME: '/configuration/theme',
      SMS: '/configuration/sms',
      DLT: '/configuration/dlt',
    },
    // Dashboard endpoints
    DASHBOARD: {
      STATS: '/dashboard/stats',
      RECENT_APPLICATIONS: '/dashboard/recent-applications',
      CHART_DATA: '/dashboard/chart-data',
      ACTIVITY_LOG: '/dashboard/activity-log',
    },
    // Banner endpoints
    BANNERS: {
      LIST: '/banners',
      DETAIL: (id) => `/banners/${id}`,
      CREATE: '/banners',
      UPDATE: (id) => `/banners/${id}`,
      DELETE: (id) => `/banners/${id}`,
      STATUS: (id) => `/banners/${id}/status`,
    },
    // States endpoints
    STATES: {
      LIST: '/states',
      DETAIL: (id) => `/states/${id}`,
      CREATE: '/states',
      UPDATE: (id) => `/states/${id}`,
      DELETE: (id) => `/states/${id}`,
      STATUS: (id) => `/states/${id}/status`,
    },
    // Banks endpoints
    BANKS: {
      LIST: '/banks',
      DETAIL: (id) => `/banks/${id}`,
      CREATE: '/banks',
      UPDATE: (id) => `/banks/${id}`,
      DELETE: (id) => `/banks/${id}`,
      STATUS: (id) => `/banks/${id}/status`,
    },
  },
};

// API Response Status
export const API_STATUS = {
  SUCCESS: 'success',
  ERROR: 'error',
  LOADING: 'loading',
};

// HTTP Status Codes
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
}; 